import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'btx-venue-parking-modal',
    templateUrl: './venue-parking-modal.component.html',
    styleUrls: ['./venue-parking-modal.component.scss']
})
export class VenueParkingModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { parkingInfo: string }) {}
}
